import { Controller } from "@hotwired/stimulus"
import { dsConfirm } from "../utils/ds_confirm";

// « Partir d'un modèle » on the one page of a flash info: asks the server for
// the slides of the template chosen (its placeholders filled for the school)
// and hands them to the slides editor, which replaces its slides.
export default class extends Controller {
  static values = { url: String, confirm: String }

  async apply(event) {
    const templateId = event.currentTarget.dataset.templateId
    this.element.open = false
    if (!templateId || !(await dsConfirm(this.confirmValue))) return

    const separator = this.urlValue.includes("?") ? "&" : "?"
    try {
      const response = await fetch(`${this.urlValue}${separator}template_id=${encodeURIComponent(templateId)}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
        },
        credentials: "same-origin",
      })
      if (!response.ok) throw new Error(`template ${response.status}`)
      const data = await response.json()
      this.dispatch("applied", { detail: { slides: data.slides || [] } })
    } catch (error) {
      console.error("Template apply error:", error)
    }
  }
}
